import * as angular from 'angular';
import CoreModule from './../core/core.module';
import homeComponent from './home.component';
import homeRoutes from './home.routes';

export default angular
  .module('FHL.home', [
    CoreModule,
  ])
  .config((RouterServiceProvider) => {
    RouterServiceProvider.configureStates(homeRoutes);
  })
  .component('home', homeComponent)
  .name;



// WEBPACK FOOTER //
// ./src/app/home/home.module.js